import React from 'react';
import { HttpError } from '../../components';

const Error403 = () => (
  <HttpError code={403} message="You don't have access to this page." />
);

export default Error403;
